(window.OEAllPosts = function ($, Behaviors) {
    "use strict";

    const module = {};

    function OEAllPosts() {
        const holders = document.querySelectorAll('.bw-all-posts-wrapper');

        if (!holders.length) {
            return;
        }

        //clear all active checkboxes
        const allTerms = document.querySelectorAll('.bw-all-posts-wrapper input[name="term"], input[name="past_events"]');
        if (allTerms.length) {
            allTerms.forEach(input => {
                if (input.getAttribute('checked') !== 'checked') {
                    input.checked = false;
                } else {
                    input.checked = true;
                }
            });
        }

        document.addEventListener('click', e => {
            const {target} = e;
            if (!target.matches('.filter-list') && !target.matches('.filter-trigger')) {
                const allFilterLists = document.querySelectorAll('.filter-list');
                if (!allFilterLists) {
                    return false;
                }
                allFilterLists.forEach(list => {
                    list.style.height = '0px';
                    list.parentElement.classList.remove('active');
                });
            }
        });

        function loadFilteredPosts(page, active_taxonomies, search, post_type, holder) {
            holder.classList.add('loading');
            const xhr = new XMLHttpRequest();
            xhr.open('POST', wpAjaxUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 400) {
                    const container = holder.querySelector('.bw-posts-holder-ajax');

                    container.innerHTML = xhr.responseText;
                    holder.classList.remove('loading');

                }
            };
            xhr.send(`action=filter_posts&paged=${page}&taxonomies=${active_taxonomies}&search=${search}&post_type=${post_type}`);
        }

        function get_active_taxonomies(items) {
            const active_items = new Map();

            if(!items.length) return '';

            items.forEach(item => {
                if (item.checked) {
                    const taxonomy = item.closest('ul').dataset.bwTaxonomy;
                    if(active_items.has(taxonomy)){
                        // If the taxonomy already exists in the Map, push the value to the existing array
                        active_items.get(taxonomy).push(item.value);
                    } else {
                        // If it does not exist, add a new array with the item value
                        active_items.set(taxonomy, [item.value]);
                    }
                }
            });

            if(active_items.size > 0) {
                // Convert the Map to a string in the format "taxonomy1:value1,value2;taxonomy2:value3,value4;..."
                return Array.from(active_items).map(([taxonomy, values]) => `${taxonomy}:${values.join(',')}`).join(';');
            }

            return '';
        }

        function toggleSlide(triggerSelector, holderSelector, defaultExpanded, triggerHolders) {
            // Get trigger and holder elements
            const trigger = triggerSelector;
            const holder = holderSelector;

            // Set default state
            holder.style.overflow = 'hidden';
            holder.style.transition = 'height 0.3s ease-in-out';
            holder.style.height = defaultExpanded ? holder.scrollHeight + 'px' : '0px';

            // Add click event listener to the trigger
            trigger.addEventListener('click', function(e) {
                const isExpanded = holder.style.height === '0px';

                //close all opened filters
                triggerHolders.forEach(triggerHolder => {
                    if(triggerHolder !== e.target.parentElement) {
                        triggerHolder.querySelector('.filter-list').style.height = '0px';
                        triggerHolder.classList.remove('active');
                    }
                });

                if(!isExpanded) {
                    holder.style.height = '0px';
                    trigger.parentElement.classList.remove('active');
                } else {
                    holder.style.height = holder.scrollHeight + 'px';
                    trigger.parentElement.classList.add('active');
                }
            });
        }

        function get_search_query(holder) {
            const searchInput = holder.querySelector('.bw-post-search');

            if (searchInput && searchInput.value) {
                return searchInput.value
            }

            return '';
        }

        function get_past_events(holder) {
            const item = holder.querySelector('input[name="past_events"]');
            if(!item) {
                return 'no';
            }
            if (item.checked) {
                return 'yes'
            }

            return 'no';
        }

        function processFiltering(page, holder) {
            const post_type = holder.querySelector('.bw_post_type').value;

            const terms = holder.querySelectorAll('input[name="term"]');

            // const active_terms = get_active_items(terms);
            const active_taxonomies = get_active_taxonomies(terms);
            // const show_past_events = get_past_events(holder);
            const search = get_search_query(holder)

            loadFilteredPosts(page, active_taxonomies, search, post_type, holder);
        }

        holders.forEach(holder => {
            // const post_type = holder.querySelector('.bw_post_type').value;

            //PAGINATION
            holder.addEventListener('click', e => {
                const {target} = e;

                if (target.matches('.bw-pagination a')) {
                    e.preventDefault();
                    const link = e.target.getAttribute('href');

                    let page = link.replace(/.*page\/(\d+).*/, '$1');
                    if (page === link) {
                        page = link.replace(/.*paged=(\d+).*/, '$1');
                        if (page === link) {
                            page = '1';
                        }
                    }

                    processFiltering(page, holder);
                    let elTopPos = getOffset(holder).top - 200;
                    window.scrollTo({top: elTopPos , left: 0, behavior: "smooth"})
                }
            });


            //Filters
            const filters = holder.querySelectorAll('.filter-trigger__term');
            if (filters.length) {
                filters.forEach(filter => {
                    filter.addEventListener('change', e => {
                        const {target} = e;

                        if (!target.matches('input[name="term"]')) {
                            return;
                        }

                        processFiltering(1, holder);
                    });
                });

            }

            const triggerHolders = holder.querySelectorAll('.bw-posts-filters__filter');
            triggerHolders.forEach(triggerHolder => {
                const trigger = triggerHolder.querySelector('.filter-trigger');
                const container = triggerHolder.querySelector('.filter-list');

                toggleSlide(trigger, container, false, triggerHolders);
            });

            //Clear Filters
            const clearFilters = holder.querySelector('.bw-clear-filter');
            if (clearFilters) {
                const post_type = holder.querySelector('.bw_post_type').value;

                clearFilters.addEventListener('click', e => {
                    const terms = holder.querySelectorAll('.bw-all-posts-wrapper input[name="term"]');
                    const pastEvents = holder.querySelector('input[name="past_events"]');
                    let isChecked = false; //add flag to check if any of the terms are active

                    //clear all active checkboxes
                    if (terms.length) {
                        terms.forEach(input => {
                            if (input.checked && input.getAttribute('checked') !== 'checked') {
                                input.checked = false;
                                isChecked = true;
                            }
                        });
                    }

                    if(pastEvents) {
                        if(pastEvents.checked) {
                            pastEvents.checked = false;
                            isChecked = true;
                        }
                    }

                    if (isChecked) { //reset if at least one of the inputs are checked
                        loadFilteredPosts(1, '', '', post_type, holder); //reset all fields
                    }
                });
            }


            //Search
            const searchInput = holder.querySelector('.bw-post-search');

            if(searchInput){
                searchInput.addEventListener('keyup', e => {
                    if (e.key === 'Enter' && !holder.classList.contains('loading')) {
                        processFiltering(1, holder);
                    }
                });

                const searchBtn = holder.querySelector('.bw-post-search-btn');

                searchBtn?.addEventListener('click', e => {
                    processFiltering(1, holder);
                });
            }


            // const pastEventsCheckbox = holder.querySelector('input[name="past_events"]');
            // if (pastEventsCheckbox) {
            //     pastEventsCheckbox.addEventListener('change', e => {
            //         processFiltering(1, holder);
            //     });
            // }
        });

        function getOffset( el ) {
            var _x = 0;
            var _y = 0;
            while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
                _x += el.offsetLeft - el.scrollLeft;
                _y += el.offsetTop - el.scrollTop;
                el = el.offsetParent;
            }
            return { top: _y, left: _x };
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        OEAllPosts();
    });


    return module;

}(window.jQuery, window.Behaviors));

